/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import classnames from 'classnames';
import styles from './GameCard.module.css';

export type GameCardProps = {
    name: string;
    src: string;
    selected?: boolean;
    disabled?: boolean;
    onSelectGame?: () => void;
};

export function GameCard({
    name,
    src = 'https://developers.unboared.com/public-assets/images/games/gloofy-pop/Icon.png',
    selected = false,
    disabled = false,
    onSelectGame,
}: GameCardProps) {
    const [loaded, setLoaded] = useState(false);

    const skeleton = classnames(
        styles.gameCard,
        disabled ? styles.disabled : '',
        styles.image,
        selected ? styles.selectedCard : '',
        loaded && styles.hide
    );

    const cardClass = classnames(
        styles.gameCard,
        disabled ? styles.disabled : '',
        styles.image,
        selected ? styles.selectedCard : '',
        !loaded && styles.hide
    );

    return (
        <div className={styles.cardContainer}>
            <div className={skeleton} onClick={onSelectGame}>
                <h3>{name}</h3>
            </div>
            <img className={cardClass} src={src} alt="game" onClick={onSelectGame} onLoad={() => setLoaded(true)} />
        </div>
    );
}
